export default "__VITE_ASSET__B$LWbZXZ__"